//Module progression
export const TRAINER = 'TRAINER'
export const AUTO = 'AUTO'

//Module status
export const COMPLETE = 'COMPLETE'
